/* eslint-disable */
import React, { useEffect } from 'react'
import { Modal } from '@mui/material'
import { CancelOutlined } from '@mui/icons-material'
import { useGetRequestBazar } from '../bazarRequests'
import { BAZAR_PAYMENT } from '../../../shared/utils/urls'

export function PaymentModal({ open, onClose, item }) {
    const getPayment = useGetRequestBazar()
    const paymentData = getPayment.response ? getPayment.response : []
    const data = paymentData ? paymentData.data : []

    useEffect(() => {
        if (open) {
            getPayment.request({
                url: BAZAR_PAYMENT,
                params: {
                    shop_id: item.shopId,
                }
            })
        }
    }, [open])

    return (
        <Modal
            open={open}
            onClose={onClose}
            className="flex items-center justify-center"
        >
            <div className="w-[350px] flex flex-col items-center gap-[10px] h-[400px] bg-white">
                <div className="w-[100%] py-[10px] bg-main-300 flex items-center justify-between px-[20px]">
                    <span className="text-white font-[600]">{item?.name}</span>
                    <button onClick={onClose} className="text-white font-[600]">
                        <CancelOutlined />
                    </button>
                </div>
                <div className="w-[100%] h-[100%] flex flex-col items-center gap-[20px] overflow-auto px-[20px]">
                    {data?.length > 0 ? (
                        data.map((items) => (
                            <div key={items.date} className="w-[100%] pb-[10px] border-b flex items-center justify-between">
                                <span className="text-black font-[500]">{items.date}</span>
                                <span className="text-black font-[500]">{items.sum}</span>
                            </div>
                        ))
                    ) : (
                        <span className="text-gray-500 mt-4">No data available</span>
                    )}
                </div>
            </div>
        </Modal>
    )
}
